interface PathConfigType {
  [path: string]: string;
}

const getFormVersion = (
  history: string[],
  // Unused since experiments went away with the BFF; kept so the callers
  // don't change. Drop it together with the `experiments` prop plumbing.
  _experiments: Experiments,
): string => {
  // If no history is provided, fall back to the current browser URL
  let fixedHistory: string[];

  if (typeof window !== 'undefined') {
    const currentAsPath = `${window.location.pathname}${window.location.search}`;

    fixedHistory = history?.length ? history : [currentAsPath || ''];
  }

  const reversedHistory = fixedHistory?.toReversed();

  // Default version (paths without a mapping below)
  let formVersion = '1.1.0';

  const versionGenerator = (
    url: string,
    pathsVersions: PathConfigType,
  ): boolean => {
    const path = url.split('?')[0];
    const matchingPathEntry = Object.entries(pathsVersions).find(
      ([mappedPath]) => path === mappedPath,
    );

    if (matchingPathEntry) {
      const [, version] = matchingPathEntry;

      formVersion = version;

      return true;
    }

    return false;
  };

  // currently the landing version of the NEW FAAF always uses the 1.3.0 version
  const versionMappings: PathConfigType = {
    '/find-an-advisor': '1.6.0',
    // Renders the same Onboarding 2.0 flow as /find-an-advisor
    '/onboarding': '1.6.0',
    '/forms/bankrate': '1.8.0',
    '/forms/nerdwallet': '1.9.0',
    '/forms/moneywise': '1.10.0',
    '/forms/usa-today': '1.11.0',
    '/forms/forbes-advisor': '1.12.0',
    '/forms/moneytalksnews': '1.13.0',
    '/forms/mybanktracker': '1.14.0',
    '/forms/cnn': '1.15.0',
    '/forms/usnews': '1.16.0',
    '/forms/money': '1.17.0', // money.com
    '/forms/investopedia': '1.18.0',
    '/forms/investor': '1.19.0',
    '/forms/expertise': '1.20.0',
    '/forms/betterbuck': '1.21.0',
    '/forms/financebuzz': '1.22.0',
    '/forms/consumervoice': '1.23.0',
    '/forms/fortune': '1.24.0',
    '/forms/kiplinger': '1.25.0',
    '/forms/kiplinger-1': '1.25.1',
    '/forms/kiplinger-2': '1.25.2',
    '/forms/kiplinger-3': '1.25.3',
    '/forms/yep-ads': '1.26.0',
    '/forms/synergy': '1.27.0',
    '/forms/joywallet': '1.28.0',
    '/forms/reddit': '1.29.0',
    '/forms/hearst': '1.30.0',
    '/forms/247wallst': '1.31.0',
    '/forms/morning-download': '1.32.0',
    '/forms/prime-women': '1.33.0',
    '/forms/moby': '1.34.0',
    '/forms/money-crashers': '1.35.0',
    '/find-your-advisor': '1.36.0',
    '/forms/comparisons': '1.37.0',
    // `/onboarding` clone for NotifyAI traffic
    '/advisor-match': '1.5.0',
  };

  reversedHistory?.some((url) => {
    return versionGenerator(url, versionMappings);
  });

  return formVersion;
};

export default getFormVersion;
